import { ABOUT_IMAGE } from "../data";
import { useReveal } from "../hooks/useReveal";

const STATS = [
  { value: "Indoor", label: "& Outdoor" },
  { value: "VEPA", label: "Made in Italy" },
];

const BLOCKS = [
  {
    title: "Soluzioni VEPA Made in Italy: design, tecnologia e qualità",
    paras: [
      "Le nostre vetrate panoramiche VEPA rappresentano l'equilibrio tra estetica minimale e funzionalità avanzata. Sistemi completamente in vetro, senza montanti verticali né elementi invasivi, progettati per lasciare protagonista la luce e mantenere una continuità visiva unica.",
      "Ogni realizzazione nasce da una progettazione attenta, dove ogni dettaglio viene studiato per integrarsi con l'architettura esistente e valorizzare terrazzi, balconi, verande e dehor.",
      "La filosofia è quella del miglior design italiano: linee pulite, materiali selezionati e soluzioni su misura capaci di adattarsi a contesti residenziali e professionali.",
    ],
  },
  {
    title: "Esperienza nel mondo del vetro indoor & outdoor",
    paras: [
      "L'esperienza maturata nel settore ci permette di affrontare ogni progetto con una visione completa: non solo la scelta del sistema più adatto, ma la capacità di interpretare lo spazio, le esigenze del cliente e gli aspetti tecnici dell'installazione.",
      "Dalle grandi aperture panoramiche alle soluzioni più complesse, ogni intervento viene seguito con attenzione e precisione, garantendo un risultato finale all'altezza delle aspettative.",
      "La nostra forza è unire progettazione e realizzazione: un unico referente per creare soluzioni in vetro belle da vedere, semplici da vivere e costruite per durare.",
    ],
  },
  {
    title: "Materiali di qualità superiore",
    paras: [
      "La qualità di una vetrata dipende dalla qualità di ogni suo componente. Per questo scegliamo sistemi e materiali progettati per offrire affidabilità, sicurezza e prestazioni elevate.",
      "Utilizziamo vetri di sicurezza e componentistica di alto livello, con particolare attenzione alla resistenza, alla scorrevolezza dei sistemi e alla pulizia estetica del risultato finale.",
      "Le soluzioni MC Slide rappresentano un punto di riferimento nel settore grazie a sistemi progettati per unire tecnologia, design e funzionalità: materiali evoluti, lavorazioni precise e soluzioni capaci di garantire eleganza minimale e durata nel tempo.",
      "Per VETRO DESIGN ITALIA la qualità non è solo una caratteristica tecnica: è il valore che accompagna ogni progetto, dalla prima consulenza fino alla consegna finale.",
    ],
  },
];

export const About = () => {
  const [ref, inView] = useReveal();
  const [ref2, inView2] = useReveal();

  return (
    <section id="chi-siamo" data-testid="about-section" className="py-24 md:py-32 px-6 md:px-12">
      <div className="max-w-[1400px] mx-auto">
        {/* Intro: squadra */}
        <div ref={ref} className="max-w-3xl mx-auto text-center mb-16">
          <p className={`text-xs uppercase tracking-[0.35em] text-champagne mb-5 reveal ${inView ? "in-view" : ""}`}>Chi Siamo</p>
          <h2 className={`font-serif font-light text-4xl sm:text-5xl tracking-tight leading-tight reveal ${inView ? "in-view" : ""}`}>
            Una squadra di professionisti del vetro, dalla progettazione alla posa.
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          <div className="relative">
            <img src={ABOUT_IMAGE} alt="Installazione vetrata panoramica VETRO DESIGN ITALIA" loading="lazy" className="w-full h-[560px] object-cover border border-black/10" />
            <div className="absolute -bottom-6 -right-6 hidden md:block bg-black text-white px-8 py-6">
              <p className="font-serif text-3xl">Osimo</p>
              <p className="text-xs uppercase tracking-[0.25em] text-white/70">Ancona · Italia</p>
            </div>
          </div>

          <div className="space-y-5 text-foreground/75 font-light leading-relaxed">
            <p>VETRO DESIGN ITALIA nasce dall'incontro tra competenze tecniche, esperienza sul campo e passione per le soluzioni in vetro capaci di trasformare gli ambienti.</p>
            <p>Dietro ogni progetto c'è una squadra specializzata che segue ogni fase del percorso: dalla consulenza iniziale alla definizione tecnica, dalla progettazione fino all'installazione finale.</p>
            <p>Il nostro team unisce competenze commerciali, tecniche e operative per offrire un servizio completo e altamente personalizzato. I nostri consulenti lavorano in sinergia con l'ufficio tecnico per analizzare ogni esigenza, studiare gli aspetti architettonici e funzionali dell'intervento e definire la soluzione più adatta a ogni spazio.</p>
            <p>La fase di installazione è affidata a professionisti con una profonda esperienza nel settore delle vetrate panoramiche e dei sistemi in vetro indoor &amp; outdoor. Una posa precisa e curata è fondamentale per garantire non solo il risultato estetico, ma anche il corretto funzionamento, la sicurezza e la durata nel tempo della soluzione installata.</p>

            <div className="grid grid-cols-2 gap-6 border-t border-black/10 pt-8 mt-8">
              {STATS.map((s) => (
                <div key={s.label} data-testid={`stat-${s.value}`}>
                  <p className="font-serif text-2xl sm:text-3xl font-light">{s.value}</p>
                  <p className="text-xs uppercase tracking-wide text-muted-foreground mt-2">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Pull quote */}
        <div className="max-w-4xl mx-auto text-center py-20 md:py-28">
          <p className="font-serif font-light text-3xl sm:text-4xl leading-snug tracking-tight">
            Non realizziamo semplici chiusure: progettiamo ambienti più <span className="text-champagne">luminosi</span>, eleganti e vivibili.
          </p>
        </div>

        {/* Content blocks */}
        <div ref={ref2} className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-14">
          {BLOCKS.map((b, i) => (
            <div key={i} className={`text-center reveal ${inView2 ? "in-view" : ""} ${i === 2 ? "md:col-span-2 md:max-w-3xl md:mx-auto" : ""}`} style={{ animationDelay: `${i * 0.1}s` }}>
              <h3 className="font-serif text-2xl font-light mb-5 leading-snug">{b.title}</h3>
              <div className="space-y-4 text-foreground/75 font-light leading-relaxed">
                {b.paras.map((p, idx) => (
                  <p key={idx}>{p}</p>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Closing */}
        <div className="mt-20 bg-black text-white p-10 md:p-16 text-center">
          <p className="text-xs uppercase tracking-[0.35em] text-champagne mb-5">VETRO DESIGN ITALIA</p>
          <h3 className="font-serif font-light text-3xl sm:text-4xl leading-tight tracking-tight mb-6 max-w-3xl mx-auto">
            Il vetro come nuovo modo di vivere gli spazi.
          </h3>
          <div className="space-y-4 text-white/70 font-light leading-relaxed max-w-2xl mx-auto">
            <p>Progettiamo e installiamo vetrate panoramiche VEPA per chi desidera unire luce, comfort e design in un'unica soluzione.</p>
            <p>Ogni spazio può diventare più aperto, più elegante e più vivibile: il nostro compito è renderlo possibile.</p>
          </div>
        </div>
      </div>
    </section>
  );
};
